var render = function render(){var _vm=this,_c=_vm._self._c;return _c('perfect-scrollbar',_vm._g(_vm._b({class:{
    'always-show-y': _vm.alwaysShowY,
    'always-show-x': _vm.alwaysShowX,
  }},'perfect-scrollbar',{..._vm.$props, ..._vm.$attrs},false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }